export const defaultTimeInterval = 15;
